import Component from './new_password_form.vue'
export default Component
